<h2 mat-dialog-title>Address</h2>
<mat-dialog-content>
  <form #addressForm="ngForm" autocomplete="off">
    <div class="row">
      <div class="col-sm-6 mb-3">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>Address Line 1</mat-label>
          <input #addressLine1="ngModel" type="text" matInput name="address_line_1" [(ngModel)]="doctorAddress.address_line_1" required>
          <mat-error *ngIf="addressLine1.invalid && addressLine1.touched">Required</mat-error>
        </mat-form-field>
      </div>
      <div class="col-sm-6 mb-3">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>Address Line 2</mat-label>
          <input type="text" matInput name="address_line_2" [(ngModel)]="doctorAddress.address_line_2">
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6 mb-3">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>State</mat-label>
          <mat-select [(value)]="selectedState">
            <input class="select-input" placeholder="Search..." type="text" autocomplete="nope" (keyup)="onStateKey($event)" matInput name="state_list">
            <mat-option *ngFor="let state of filteredStates" [value]="state.id">{{state.name}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-sm-6 mb-3">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>City</mat-label>
          <mat-select [(value)]="selectedArea">
            <input class="select-input" type="text" autocomplete="nope" (keyup)="onAreaKey($event)" matInput placeholder="Search..." name="area_list">
            <mat-option *ngFor="let area of filteredAreas" [value]="area.id">{{area.name}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6 mb-3">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>Pincode</mat-label>
          <input type="text" matInput name="pincode" [(ngModel)]="doctorAddress.pincode">
        </mat-form-field>
      </div>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button type="button" mat-stroked-button (click)="close()">Discard</button>
  <button type="button" mat-flat-button color="primary" (click)="saveAddress(addressForm.valid)">Add</button>
</mat-dialog-actions>